import React from "react";
import List from "app/component/list/List";

const AgreementList: React.FC = () => {
  return <List isAgreement={true} />;
};

export default AgreementList;
